'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'

// const contents = [
//   {
//     title: 'Termos de Uso',
//     url: '/termos-de-uso',
//   },
//   {
//     title: 'Política de Privacidade',
//     url: '/politica-de-privacidade',
//   },
//   {
//     title: 'Política de Reembolso',
//     url: '/politica-de-cancelamento-e-reembolso',
//   },
// ]

interface AsideSelectionTermProps {
  contents: {
    title: string
    url: string
  }[]
}

export default function AsideSelectionTerm({
  contents,
}: AsideSelectionTermProps) {
  const pathname = usePathname()

  return (
    <aside className="mt-6 min-w-64">
      <div className="border-primary-100 border-b-2 pb-5">
        <h4 className="font-medium text-gray-400 text-sm">Conteúdo</h4>
        <ul className="mt-2 space-y-4">
          {contents.map(({ title, url }) => (
            <li key={title}>
              <Link href={url}>
                <button
                  className="relative font-medium text-gray-900 text-lg ease-out after:absolute after:bottom-0 after:left-0 after:block after:h-0.5 after:w-full after:origin-bottom-right after:scale-x-0 after:bg-primary-600 after:transition-transform after:duration-500 after:content-[''] hover:after:origin-bottom-left hover:after:scale-100 data-[selected=true]:after:scale-100"
                  data-selected={pathname === url}
                  type="button"
                >
                  {title}
                </button>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  )
}
